export const transactionInOutStatuses = {
  0: { text: 'completed', theme: 'success' },
  3: { text: 'errorLw', theme: 'danger' },
  4: { text: 'pending', theme: 'warning' },
  6: { text: 'errorPsp', theme: 'danger' },
  7: { text: 'cancelled', theme: 'danger' },
  14: { text: 'scheduled', theme: 'warning' },
  16: {
    text: 'authorized',
    theme: 'info'
  },
  17: { text: 'cardRegistration ', theme: 'info' },
  20: { text: 'closed', theme: 'neutral' },
  21: { text: 'partiallyCaptured', theme: 'info' },
  22: { text: 'requested', theme: 'warning' }
};

export const transactionP2PStatuses = {
  p3: {
    text: 'completedP2P',
    theme: 'success'
  },
  p4: { text: 'errorP2P', theme: 'danger' },
  p13: { text: 'cancelledP2P', theme: 'danger' },
  p5: { text: 'pendingP2P', theme: 'warning' },
  p14: { text: 'processingP2P', theme: 'info' }
};

export const transactionStatuses = {
  ...transactionInOutStatuses,
  ...transactionP2PStatuses
};

export const transactionBankingStatuses = [
  { value: 0, text: 'orderedByPartner', theme: 'neutral', icon: 'schedule' },
  {
    value: 1,
    text: 'automaticallyTreated',
    theme: 'neutral',
    icon: 'Check'
  },
  { value: 2, text: 'postponed', theme: 'neutral', icon: 'schedule' },
  {
    value: 3,
    text: 'manuallyTreated',
    theme: 'neutral',
    icon: 'Check'
  },
  { value: 5, text: 'toBeChecked', theme: 'neutral', icon: 'policy' },
  { value: 6, text: 'blockedByCompliance', theme: 'neutral', icon: 'block' },
  { value: 7, text: 'toBeSent', theme: 'neutral', icon: 'send' },
  { value: 8, text: 'cancelled', theme: 'neutral', icon: 'cancel' },
  { value: 100, text: 'missingData', theme: 'neutral', icon: 'warning' },
  { value: 101, text: 'blacklisted', theme: 'neutral', icon: 'block' }
];
